<template>
    <div class="dt-search-bars">
        <div class="dt-search-bar-search-sec">
            <slot name="filterSlot"></slot>
        </div>
        <div class="dt-search-bar-add-sec">
            <slot name="addFilterSlot"></slot>
        </div>
        <div class="dt-search-bar-btn-sec">
            <slot name="buttonSlot"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "dt-search-bar",
        data() {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    .dt-search-bars {
        min-height: 40px;
        margin: 15px 0 10px 0;
        display: flex;
        align-items: center;
    }
</style>
<style lang="scss">
    .dt-search-bars {
        &-search-sec {
            float:left;
        }
        &-add-sec{
            float: left;
            display: flex;
        }
        &-btn-sec {
            position: absolute;
            right: 5px;
        }
    }
</style>
